<!--格式校验通过才向父组件emit数据-->
<template>
  <section class="custom-textarea">
    <!-- v-model.trim -->
    <s-textarea
      class="textarea"
      :rows="rows"
      :placeholder="$attrs.placeholder ? $attrs.placeholder : tip"
      :class="{ error: !isValidated }"
      v-model.trim="url"
      @change="handleChange"
      v-bind="$attrs"
      v-on="$listeners"
    ></s-textarea>
    <span class="error" v-show="!this.isValidated">{{ error }}</span>
    <s-input
      ref="verifyInput"
      class="verify"
      v-model="url"
      v-bind="$attrs"
      :class="{ hidden: !isValidated }"
    ></s-input>
  </section>
</template>

<script>
export default {
  name: 'commonUrlTextarea',
  props: {
    value: [String, Number],
    rows: {
      type: Number,
      default() {
        return 3
      },
    },
    type: {
      type: String,
      default() {
        return 'url'
      },
    },
    validateeachinput: {
      type: Boolean,
      default() {
        return true
      },
    },
  },
  data() {
    let type_reg = {
      number: /^\d*$/,
      text: new RegExp(),
      url: new RegExp(
        '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
        'i'
      ),
    }
    let tip = 'Please enter url'
    return {
      url: '',
      error: '',
      type_reg: type_reg,
      tip: tip,
      error_msg: {
        number: 'Number Format Error',
        url: 'Url Format Error',
        domain: 'Domain Format Error',
      },
      isValidated: true,
    }
  },
  created() {
    this.url = this.value
  },
  watch: {
    value(newVal) {
      this.url = this.value
      this.handleChange(newVal)
    },
  },
  methods: {
    handleChange(val) {
      let type = this.type
      this.isValidated = true
      // let zero_width_char = [
      //   '\u200b',
      //   '\u200c',
      //   '\u200d',
      //   '\u200e',
      //   '\u200f',
      //   '\uFEFF',
      //   '\u00A0',
      //   '\u0020',
      //   '\u3000',
      // ] // 部分零宽字符,三种空格(\u00A0,\u0020,\u3000)
      // let reg = new RegExp(zero_width_char.join('|'), 'gi')
      // this.url = val.replace(reg, '').trim()
      if(val){
        this.url = val.trim()
      }
      if (this.url !== '') {
        this.isValidated = this.type_reg[type].test(this.url)
        if (!this.isValidated) {
          this.error = this.error_msg[type]
        }
      }
      this.$emit('input', this.url)
      if (this.validateeachinput) {
        this.$refs.verifyInput && this.$refs.verifyInput.change()
      }
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.custom-textarea
  height: auto;
  .message
    position: absolute;
    color: #db5868;
    font-size: 12px;
  .error
    textarea
      font-size: 14px;
      color: #68696b;
      border: 1px solid #db5868;
      border-radius: 2px;
  .verify
    input
      width: 0;
      min-width: unset!important;
      height: 0!important;
    .msg
      position: relative;
      display: inline-block;
      top: 0;
      right: 0;
      &.msg-icon
        display: none;
</style>
